export const validationContent = {
    LOGIN_PAGE: {
        phone: "Please enter your WhatsApp number.",
        countryCode: 'Please Enter the Country Code',
        phoneNo: "Mobile Number must be exactly 10 digits.",
        OTP: "Please Enter Your OTP.",
        OTPCount: 'OTP must be exactly 6 digits'
    },
    SIGNUP_STEPS: {
        InvalidGSTIN: "Please enter a valid GSTIN.",
        EnterPAN: "Please enter your PAN number.",
        InvalidPANFormat: "PAN number must follow the format AAAAA9999A.",
        EnterDescription: "Please enter your description.",
        ImageSizeExceeded: "Image dimensions must not exceed 5000 pixels in width or height.",
        EnterBusinessAddress: "Please enter your business address.",
        EnterContactPersonName: "Please enter the contact person's name.",
        SelectState: "Please select the state",
        InvalidPIN: "Please enter a valid PIN"
    },
    BUSINESS_INFO_PAGE: {
        EnterBusinessName: "Please enter your business name.",
        EnterBusinessDescription: "Please enter your business description.",
        EnterBusinessAddress: "Please enter your address.",
        EnterContactPersonName: "Please enter contact person name.",
        LogoResolutionExceeded: "Image resolution should not exceed 1500 x 500 pixels.",
        LogoSizeExceeded: "Image size should not exceed 5 MB."
    },
    BILLING_ADDRESS_POPUP: {
        EnterName: "Please enter your name.",
        EnterBillingAddress: "Please enter the address.",
        EnterTownCity: "Please enter the town/city.",
        EnterPinCode: "Please enter the pin code."
    },
    AD_CREATION: {
        MissingBanner: "Upload a poster to proceed.",
        MissingLocation: "Location not found. Please enter a valid location.",
        InvalidFacebookURL: "Please enter a valid Facebook Page URL.",
        InvalidInstagramURL: "Please enter a valid Instagram Profile URL.",
        InvalidLocationURL: "Please enter a valid Google Maps location URL."
    },
    CATALOG_CREATION: {
        MissingTitle: "Please add a title to continue.",
        MissingDescription: "Please add a description to continue."
    },
    PROFILE_CREATION: {
        EnterFullName: "Please enter your full name.",
        EnterMotherTongue: "Please select your mother tongue.",
        EnterDOB: "Please enter your date of birth.",
        SelectGender: "Please select your gender.",
        SelectMaritalStatus: "Please select your marital status.",
        SelectReligion: "Please select your religion.",
        SelectCaste: "Please select your caste.",
        SelectHeight: "Please select your height.",
        SelectBirthStar: "Please select your birth star.",
        SelectJob: "Please select your job.",
        SelectEducation: "Please select your education.",
        SelectDisabilityStatus: "Please select your disability status.",
        SelectLocation: "Please select your location.",
        EnterBio: "Please enter your bio.",
        UploadImage: "Please upload a profile image.",
        InvalidImageSize: "Image size should not exceed 5 MB.",
        InvalidImageFormat: "Please upload a valid image format (JPG, PNG, GIF)."
    }
};
